import * as actionType from '../actionTypes/actionTypes';

const initialState = [];

// reducer for frontend skills
const frontendSkillsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SET_FRONTEND_SKILLS:
      return action.payload;
    default:
      return state;
  }
};

// reducer for backend skills
const backendSkillsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SET_BACKEND_SKILLS:
      return action.payload;
    default:
      return state;
  }
};

// reducer for tools skills
const toolSkillsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SET_TOOL_SKILLS:
      return action.payload;
    default:
      return state;
  }
};

// reducer for communication skills
const communicationSkillsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SET_COMMUNICATION_SKILLS:
      return action.payload;
    default:
      return state;
  }
};

// reducer for soft skills
const softSkillsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SET_SOFT_SKILLS:
      return action.payload;
    default:
      return state;
  }
};

// Reducer for projects data
const allProjectsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SET_ALL_PROJECTS_DATA:
      return action.payload;
    default:
      return state;
  }
};

// reducer for Testimonials Data
const allTestimonialsDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SET_ALL_TESTIMONIALS_DATA:
      return action.payload;
    default:
      return state;
  }
};

export {
  frontendSkillsReducer,
  backendSkillsReducer,
  toolSkillsReducer,
  communicationSkillsReducer,
  softSkillsReducer,
  allProjectsReducer,
  allTestimonialsDataReducer,
};
